import { useEffect, useState } from "react";
import { ProfileWrapper } from "./style";
import { useSelector, useDispatch } from "react-redux";

import Text from "components/common/Text";
import Button from "components/common/Button";
import Input from "components/common/Input";
import CustomDatePicker from "components/common/CustomDatePicker";

import Translation from "libs/Translation";
import Util from "libs/Util";
import ToastManager from "libs/ToastManager";
import ModalManager from "libs/ModalManager";

import { setUserAction } from "redux/user/actions";
import { postAPI, getAPI } from "redux/core/actions";

const CreateProfile = ({ webConfig }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);

  const [invalidField, setInvalidField] = useState([]);
  const [loading, setLoading] = useState();
  const [birthDate, setBirthDate] = useState();
  const [finalValue, setFinalValue] = useState({ phoneNumber: user?.phone });

  const inputs = [
    {
      id: 0,
      label: Translation.t("label.name"),
      name: "FirstName",
      type: "input",
      errorText: Translation.t("text.invalid-first-name"),
    },
    {
      id: 1,
      label: Translation.t("label.last-name"),
      name: "LastName",
      type: "input",
      errorText: Translation.t("text.invalid-last-name"),
    },
    {
      id: 3,
      label: Translation.t("label.id-number"),
      name: "NationalCode",
      type: "input",
      errorText: Translation.t("text.invalid-national-code"),
    },
    {
      id: 4,
      label: Translation.t("label.birth-date"),
      name: "BirthDate",
      type: "date-picker",
    },
  ];

  useEffect(() => {
    setFinalValue({ ...finalValue, ...birthDate });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [birthDate]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    const newValue = { [name]: Util.convertToEngNum(value) };

    setInvalidField([]);
    setFinalValue({ ...finalValue, ...newValue });
  };

  const handleChangeDate = (value) => {
    setInvalidField([]);
    setBirthDate(value);
  };

  const validation = () => {
    let invalid = invalidField;
    let valid = true;
    if (Util.validateNationalCode(finalValue?.NationalCode) !== true) {
      invalid = [...invalid, "NationalCode"];
      valid = false;
    }
    if (Util.validateName(finalValue.FirstName) !== true) {
      invalid = [...invalid, "FirstName"];
      valid = false;
    }
    if (Util.validateName(finalValue.LastName) !== true) {
      invalid = [...invalid, "LastName"];
      valid = false;
    }
    setInvalidField(invalid);
    return valid;
  };

  const handleConfirm = (e) => {
    e.preventDefault();

    if (validation()) {
      setLoading(true);

      const body = {
        FirstName: finalValue.FirstName,
        LastName: finalValue.LastName,
        Gender: finalValue.Gender ?? 1,
        NationalCode: finalValue.NationalCode,
        BirthDate: finalValue.BirthDate, // ISO string expected by Nest
      };

      dispatch(postAPI("createProfile", body, null, "nestApi"))
        .then((createdProfile) => {
          if (createdProfile && (createdProfile.id || createdProfile._id)) {
            // append the new profile to user state
            dispatch(
              setUserAction({
                ...user,
                profiles: [...(user.profiles || []), createdProfile],
              })
            );

            ToastManager.show(Translation.t("text.logged-in"), webConfig);
            ModalManager.hide();
          } else {
            ToastManager.show(Translation.t("text.error-occurred"), webConfig);
          }
        })
        .catch((err) => {
          console.error(err);
          ToastManager.show(Translation.t("text.error-occurred"), webConfig);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <ProfileWrapper onSubmit={handleConfirm}>
      <Text tag="span" className="title">
        {Translation.t("label.user-info")}
      </Text>
      <div className="inputs">
        {inputs.map((i) => (
          <div key={i.id} className="input">
            {i.type === "input" ? (
              <Input
                name={i.name}
                handleChange={handleChange}
                value={finalValue[i.name]}
                label={i.label}
                style={{ direction: webConfig.dir }}
                errorText={
                  invalidField?.length && invalidField?.includes(i.name)
                    ? i.errorText
                    : null
                }
              />
            ) : i.type == "date-picker" ? (
              <CustomDatePicker
                label={i.label}
                onChange={handleChangeDate}
                name={i.name}
                webConfig={webConfig}
                defaultVal={finalValue[i.name]}
              />
            ) : null}
          </div>
        ))}
      </div>
      <Button
        className="book-button"
        loading={loading}
        disabled={Object.keys(finalValue).length !== 5}
        type="submit"
      >
        {Translation.t("label.submit-info")}
      </Button>
    </ProfileWrapper>
  );
};
export default CreateProfile;
